import { ReactNode } from 'react'
import { TUCI_VERIFICATION_FAILED, TUCI_INTERNAL_ERROR, MAX_ENROLLMENTS_ERROR_CODE, CREDIT_USER_BLOCKED } from 'constants/errors'

export const USER_BLOCKED_TITLE = (
  <span data-qa-marker='user-blocked-title'>
    We are unable to verify your identity using the information you provided.
  </span>
)

// Please check appearance when you use it:
// it may look badly because of <br /> in middle of sentence
export const USER_BLOCKED_TEXT = (
  <div data-qa-marker='user-blocked-text'>
    For security reasons, you are required to wait at least 24
    <br />
    hours before attempting to link your credit file again.
  </div>
)

const RETRY_TEXT = (
  <div>
    We were not able to verify your identity with TransUnion&reg;<br />
    using the information you provided. <br />
    Please verify your information is correct and retry.
  </div>
)

const TUCI_BLOCK_TEXT = (
  <div>
    TransUnion&reg; has indicated that there is an issue with your credit file, <br />
    which is preventing us from linking it. Please contact TransUnion&reg; at: (800)916-8800. <br />
    You can retry if any of the information you provided may have been incorrect.
  </div>
)

export const CONNECTION_ERROR_TEXT = (
  <div>
    We are having connectivity problems with TransUnion&reg;. We apologize for the inconvenience. <br />
    Please try to link your credit file again.
  </div>
)

const BAD_CREDIT_HISTORY_TEXT = (
  <div>
    You may have insufficient credit history.<br />
    Please retry if any of the information you provided may have been incorrect.
  </div>
)

const MAX_ENROLLMENTS_TEXT = (
  <div>
    It appears that you have enrolled in multiple similar services in the last 30 days. <br />
    For your protection, TransUnion&reg; is not able to link your credit file at this time. <br />
    Please try again in a few days.
  </div>
)

export const TUCI_ERRORS_MAP: Record<string, ReactNode> = {
  // retry
  [TUCI_VERIFICATION_FAILED]: RETRY_TEXT,
  ssn_not_found: RETRY_TEXT,
  invalid_input: RETRY_TEXT,
  data_mismatch: RETRY_TEXT,
  credit_file_pull_failed: RETRY_TEXT,
  credit_file_not_found: RETRY_TEXT,

  // connection error
  [TUCI_INTERNAL_ERROR]: CONNECTION_ERROR_TEXT,
  service_unavailable: CONNECTION_ERROR_TEXT,
  service_error: CONNECTION_ERROR_TEXT,

  // TUCI block
  credit_file_suppressed: TUCI_BLOCK_TEXT,
  person_deceased: TUCI_BLOCK_TEXT,
  fraud_alert: TUCI_BLOCK_TEXT,

  insufficient_credit_activity: BAD_CREDIT_HISTORY_TEXT,

  // out block
  [MAX_ENROLLMENTS_ERROR_CODE]: MAX_ENROLLMENTS_TEXT,
  [CREDIT_USER_BLOCKED]: USER_BLOCKED_TEXT,
}
